import DataBase from "./data_base";
import GraphContainer, { getOrSet } from "../graph_container";
import GraphGroup from "../graph_group";

class DataArbitrary extends DataBase {
    constructor(graphing) {
        super(graphing);

        /**
         * @type {THREE.Vector2[]}
         */
        this._points = [new THREE.Vector2(-1, -1), new THREE.Vector2(1, 1)];

        this._path = GraphContainer.create("path");
        this._gPoints = new GraphGroup();
        this.append(this._path, this._gPoints);

        this._width = 5;
        this._radius = 0;
        this._editing = false;
        this._drawpoints = [];
    }

    _serialize() {
        return {
            width: this._width,
            radius: this._radius,
            points: this._points.map(p => p.toArray()).flat()
        };
    }

    get type() { return "arbitrary"; }
    get defaultName() { return "Arbitrary"; }

    /**
     * @returns {this}
     */
    width() { return getOrSet.call(this, this, "_width", ...arguments); }

    /**
     * @returns {this}
     */
    radius() { return getOrSet.call(this, this, "_radius", ...arguments); }

    /**
     * @returns {this}
     */
    editing() { return getOrSet.call(this, this, "_editing", ...arguments); }

    /**
     * @returns {this}
     */
    points() { return getOrSet.call(this, this, "_points", ...arguments); }

    /**
     * @returns {this}
     */
    drawpoints() { return getOrSet.call(this, this, "_drawpoints", ...arguments); }


    redraw() {
        const len = this._drawpoints.length;
        const path = len > 2 && this._width > 0
            ? `M${this._drawpoints[0]} ${this._drawpoints[1]} L${this._drawpoints.slice(2).join(" ")}`
            : "";

        this._gPoints.erase();
        const radius = this._editing ? 5 : this._radius;
        if (radius > 0) {
            const color = this._editing ? "red" : this._color;

            for (let i = 0; i < len; i += 2) {
                const p = GraphContainer.create("circle")
                    .setAttribute("r", radius)
                    .setAttribute("cx", this._drawpoints[i])
                    .setAttribute("cy", this._drawpoints[i + 1])
                    .setAttribute("fill", color);

                this._gPoints.append(p);
            }
        }

        this._path
            .setAttribute("stroke", this._color)
            .setAttribute("fill", "none")
            .setAttribute("stroke-width", this._width)
            .setAttribute("stroke-linecap", "round")
            .setAttribute("d", path);

        return this;
    }

    static deserialize(graphing, data) {
        const g = new DataArbitrary(graphing).deserialize(data);

        g._width = "width" in data ? data.width : g._width;
        g._radius = "radius" in data ? data.radius : g._radius;

        if ("points" in data) {
            while (g._points.pop()) { }
            for (let i = 0, len = data.points.length; i < len; i += 2) {
                g._points.push(new THREE.Vector2().fromArray(data.points, i));
            }
        }

        return g;
    }
}

export default DataArbitrary;
export { DataArbitrary };